import React from "react";
import { Button, Icon, Modal } from "semantic-ui-react";
import Wave2 from "../../../images/modalWave2.svg";
import './ConfirmDeleteModal.scss';

export type ConfirmDeleteProps = {

    icon: string; // icon to display example for trash can ```trash alternate outline```
    confirmDeleteFunc: Function; // delete function you will pass the itemToDelete to
    displayName: string; // name to display in the modal
    itemToDelete: any; // Send this to confirmDeleteFunc on delete
    theme?: string; // primary secondary tertiary white
}

export const ConfirmDeleteModal: any = (props: ConfirmDeleteProps) => {

    const [open, setOpen] = React.useState(false);

    const deleteAndClose = () => {
        props.confirmDeleteFunc(props.itemToDelete);
        setOpen(false);
    }

    return (
            <Modal className="confirm-delete-modal"
                size="tiny"
                centered={true}
                open={open}
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                trigger={<Icon className={`${props.icon} ${props.theme} trash-icon`} name="trash" />}
            >
                <Modal.Header>Are you sure you want to delete?</Modal.Header>
                <Modal.Content>{props.displayName}</Modal.Content>

                <Modal.Actions>
                <div className="wave-div">
                    <img src={Wave2} alt="wave" className="wave" />
                </div>
                <div className="modal-btns">
                    <Button color="red" onClick={() => deleteAndClose()}>Delete</Button>
                    <Button color="grey" onClick={() => setOpen(false)}>Cancel</Button>
                </div>
                </Modal.Actions>
            </Modal>
    )
}